import RegisterForm from './RegisterForm';
import RegisterPageTitle from './RegisterPageTitle';
import { getRegisterDefaultValues } from './useRegisterDefaultValues';
import { getRegisterSchema } from './useRegisterSchema';
import useRegisterSubmit from './useRegisterSubmit';
import type { IntentParams } from './queries/useRegisterMutation';
import { UserRegistrationType } from '@/services/register.types';
import FormWithProvider from '@/components/forms/form/Form';

interface RegisterFormSectionProps {
  email: string;
  registrationType: UserRegistrationType;
  registrationToken: string;
  intentParams: IntentParams;
}

const RegisterFormSection = ({
  email,
  registrationType,
  registrationToken,
  intentParams,
}: RegisterFormSectionProps) => {
  const { handleSubmitRegister, clearErrors, errorMessage, isSubmitting } =
    useRegisterSubmit({ registrationToken, intentParams });

  const schema = getRegisterSchema(registrationType);
  const defaultValues = getRegisterDefaultValues(registrationType, email);

  return (
    <FormWithProvider
      horizontal
      onSubmit={handleSubmitRegister}
      resolver={schema}
      defaultValues={defaultValues}
    >
      <RegisterPageTitle />
      <RegisterForm
        clearErrors={clearErrors}
        errorMessage={errorMessage}
        isSubmitting={isSubmitting}
        registrationType={registrationType}
      />
    </FormWithProvider>
  );
};

export default RegisterFormSection;
